import Button from '@atoms/Button'

import { scopedTranslation } from '@utils/I18n'
import { ShiftPublishState } from '@frontend/graphql/types.generated'

import { useShiftsStore } from '../roster_board/stores/useShiftsStore'
import { hasPerShiftPublish } from '../shifts/publishState'
import type { ShiftWithSlots } from '../shifts/types'

const t = scopedTranslation('components.publish_roster')

type PublishLinkProps = {
  shift: ShiftWithSlots
}

export const PublishLink = ({ shift }: PublishLinkProps) => {
  const openPublish = useShiftsStore((state) => state.openPublish)

  if (!hasPerShiftPublish(shift)) return null

  return (
    <Button rank="link" size="sm" leadingIcon="check" onClick={() => openPublish([shift.id])}>
      {shift.publishState === ShiftPublishState.Draft ? t('publish_shift') : t('publish_changes')}
    </Button>
  )
}
